import {
  stringIdfy
} from "./chunk-EOOX52TY.jsx";
import {
  __name
} from "./chunk-DVUTYNGK.jsx";

// src/utils/common/common.ts
var toBase64 = /* @__PURE__ */ __name((s) => typeof window === "undefined" ? Buffer.from(s).toString("base64") : window.btoa(s), "toBase64");
function throttle(callback, thresholdTriggerMs) {
  let lastTime = 0;
  return function(...args) {
    const now = (/* @__PURE__ */ new Date()).getTime();
    if (now - lastTime >= thresholdTriggerMs) {
      callback.apply(this, args);
      lastTime = now;
    }
  };
}
__name(throttle, "throttle");
function debounce(callback, wait, immediate = false) {
  let timeout;
  return function(...args) {
    const later = /* @__PURE__ */ __name(() => {
      timeout = null;
      if (!immediate) callback.apply(this, args);
    }, "later");
    if (typeof timeout === "number") clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (immediate && !timeout) callback.apply(this, args);
  };
}
__name(debounce, "debounce");
var generateUniqueId = /* @__PURE__ */ __name(() => crypto.randomUUID(), "generateUniqueId");
var generateSidenavId = /* @__PURE__ */ __name((heading) => {
  return `sidenav-${stringIdfy(heading)}`;
}, "generateSidenavId");
var handleSettledPromiseResults = /* @__PURE__ */ __name(({
  results,
  errorMsg
}) => {
  const errors = results.map(
    (result) => result.status === "rejected" && (result == null ? void 0 : result.reason)
  );
  if (errors.length && errorMsg) {
    throw new Error(errorMsg);
  }
  return results.map(
    (result) => result.status === "fulfilled" && (result == null ? void 0 : result.value)
  );
}, "handleSettledPromiseResults");

export {
  toBase64,
  throttle,
  debounce,
  generateUniqueId,
  generateSidenavId,
  handleSettledPromiseResults
};
